import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTasmotaComponent } from './simple-icons-tasmota.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTasmotaComponent ],
    exports:      [ SimpleIconsTasmotaComponent ],
    bootstrap:    []
})
export class SimpleIconsTasmotaModule {}
